<div class="layout-ParentDiv innerDiv UserRedemptionPage"
  [ngClass]="hide ? 'hide-bank-small  ' : 'show-bank-details-section '">
  <div class="layout-dashboard">
    <p-toast key="toastmsg"></p-toast>

    <div class="show-table-active" [ngClass]="hide ? 'show-table-active   ' : 'show-table-active  '">
      <p-toast key="toastmsg"></p-toast>

      <div class="mainDivHeader">
        <div class="leftdiv">
          <h4>Court Bookings Revenue<span class="badge">{{ totalRecords }}</span></h4>
        </div>

        <div class="rightDiv">
          <button class="exportBTn" (click)="exportExcel()"> <span><img
                src="../../../assets/images/backend-image/header/exportIcon.svg" alt=""></span>
            Export</button>
        </div>
      </div>

      <div class="mainDivBody"> 
        <div class="date-filterDiv">
          <ul class="filtersList">
            <li>
              <p-dropdown inputId="searchfield" [options]="searchBy" [(ngModel)]="searchby"
                optionLabel="label"></p-dropdown>
            </li>
            <li>
              <p-calendar monthNavigator="true" yearNavigator="true" yearRange="2022:2050" [(ngModel)]="startDate"
                class="p-calendar w-100" inputId="calendar" dateFormat="dd/mm/yy" [showIcon]="true"
                placeholder="FROM: dd / mm / yy"></p-calendar>
            </li>
            <li>
              <p-calendar monthNavigator="true" yearNavigator="true" yearRange="2022:2050" [(ngModel)]="endDate"
                class="p-calendar" inputId="calendar" dateFormat="dd/mm/yy" [showIcon]="true"
                placeholder="To: dd / mm / yy"></p-calendar>
            </li>
            <li>
              <button (click)="loadCourtBookingsRevenue(lastTableLazyLoadEvent)" class="searchFilterBtn">
                <img src="../../../assets/images/backend-image/common-images/search.svg" alt="">
              </button>
            </li>
            <li>
              <button (click)="clear()" class="clearFilterBtn">
                <img src="../../../assets/images/backend-image/common-images/delete.svg" alt="">
                <span>Clear All</span>
              </button>
            </li>
          </ul>
          <div class="divider ">
            <hr>
          </div>
          <div class="filterTitle">
            <h5>Filters</h5>
            <span class="text-danger fw-bold mb-3">Note:</span>
            <ul class="mb-3">
              <li>Please select a Country first to view available States.</li>
              <li>Please select a State first to view available Cities.</li>
            </ul>
          </div>
           <div class="maincard">
            <div class="filterList">
              <ul>
                <li>
                 <p-dropdown inputId="totalCoaches" [options]="countrylist" [filter]="true"
                    (onChange)="getStates($event)" placeholder="Select Country" optionLabel="name" appendTo="body"
                    [showClear]="true" [(ngModel)]="country"></p-dropdown>
                </li>
                 <li>
                  <p-dropdown inputId="totalCoaches" [options]="stateList" [filter]="true"
                    (onChange)="getCities($event)" placeholder="Select State" optionLabel="name" appendTo="body"
                    [showClear]="true" [(ngModel)]="state"></p-dropdown>
                </li>
                  <li>
               <p-dropdown inputId="totalCoaches" [options]="cityList" [filter]="true"
                    (onChange)="loadCourtBookingsRevenue(lastTableLazyLoadEvent)" placeholder="Select City"
                    optionLabel="name" optionValue="name" appendTo="body" [showClear]="true"
                    [(ngModel)]="cityName"></p-dropdown>
                </li>
                <li>
             <p-dropdown inputId="totalCoaches" [options]="academiesList" [filter]="true"
                    (onChange)="onAcademyChange($event)" placeholder="Select Academy"
                    optionLabel="name" optionValue="id" appendTo="body" [showClear]="true"
                    [(ngModel)]="academyId"></p-dropdown>
                </li>
               
                <li>
                   <p-dropdown inputId="totalCoaches" [options]="sportList" [filter]="true"
                    (onChange)="onSportChange($event)" placeholder="Select Sport"
                    optionLabel="name" optionValue="id" appendTo="body" [showClear]="true"
                    [(ngModel)]="sportName"></p-dropdown>
                </li>
              
                <li>
                <p-dropdown inputId="totalCoaches" [options]="venueList" [filter]="true"
                  (onChange)="onVenueChange($event)" placeholder="Select Venue" optionLabel="courtName"
                  optionValue="id" appendTo="body" [showClear]="true" [(ngModel)]="venueId"></p-dropdown>
                </li>
              </ul>
            </div>
          </div> 
          <div class="detailsList">
          <ul>
            <li>
              <div class="cardDiv">
                  <div class="titleHeading">
                    <h6>Total Number of Users</h6>
                  </div>
                  <div class="mainText">
                    <h3>{{ courtBookingsRevenueData?.summary?.totalNumberOfUsers }}</h3>
                  </div>
              </div>
            </li>
            <li>
              <div class="cardDiv">
                  <div class="titleHeading">
                    <h6>Total Bookings Made</h6>
                  </div>
                  <div class="mainText">
                    <h3>{{ courtBookingsRevenueData?.summary?.totalBookingsMade }}</h3>
                  </div>
              </div>
            </li>
            <li>
              <div class="cardDiv">
                  <div class="titleHeading">
                    <h6>Total Booking Amount</h6>
                  </div>
                  <div class="mainText">
                    <h3>{{ courtBookingsRevenueData?.summary?.totalBookingAmount | number:'0.2-2' }}</h3>
                  </div>
              </div>
            </li>
            <li>
              <div class="cardDiv">
                  <div class="titleHeading">
                    <h6>Total Coupon Amount (Venue)</h6>
                  </div>
                  <div class="mainText">
                    <h3>{{ courtBookingsRevenueData?.summary?.totalCouponAmountVenue | number:'0.2-2' }}</h3>
                  </div>
              </div>
            </li>
            <li>
              <div class="cardDiv">
                  <div class="titleHeading">
                    <h6>Total Coupon Amount (TPL)</h6>
                  </div>
                  <div class="mainText">
                    <h3>{{ courtBookingsRevenueData?.summary?.totalCouponAmountTPL | number:'0.2-2' }}</h3>
                  </div>
              </div>
            </li>
            <li>
              <div class="cardDiv">
                  <div class="titleHeading">
                    <h6>Total TPL Commission</h6>
                  </div>
                  <div class="mainText">
                    <h3>{{ courtBookingsRevenueData?.summary?.totalTPLCommission | number:'0.2-2' }}</h3>
                  </div>
              </div>
            </li>
            <li>
              <div class="cardDiv">
                  <div class="titleHeading">
                    <h6>Total TPL Add On Commission</h6>
                  </div>
                  <div class="mainText">
                    <h3> {{ courtBookingsRevenueData?.summary?.totalTPLAddOnCommission | number:'0.2-2' }}</h3>
                  </div>
              </div>
            </li>
            <li>
              <div class="cardDiv">
                  <div class="titleHeading">
                    <h6>Total TPL Revenue</h6>
                  </div>
                  <div class="mainText">
                    <h3>{{ courtBookingsRevenueData?.summary?.totalTPLRevenue | number:'0.2-2' }}</h3>
                  </div>
              </div>
            </li>
            <li>
              <div class="cardDiv">
                  <div class="titleHeading">
                    <h6>Total Venue Payout</h6>
                  </div>
                  <div class="mainText">
                    <h3>{{ courtBookingsRevenueData?.summary?.totalVenuePayout | number:'0.2-2' }}</h3>
                  </div>
              </div>
            </li>
            <li>
              <div class="cardDiv">
                  <div class="titleHeading">
                    <h6>Total TPL Share</h6>
                  </div>
                  <div class="mainText">
                    <h3>{{ courtBookingsRevenueData?.summary?.totalTPLShare | number:'0.2-2' }}</h3>
                  </div>
              </div>
            </li>
          </ul>
        </div>  
        </div>
        <div class="maintableDiv">
          <div class="tableParanet">
            <p-table class="expandable" #dt [value]="courtBookingsRevenueData?.data" [autoLayout]="true" [paginator]="true" [rows]="10"
              [lazy]="true" [scrollable]="true" scrollHeight="auto" scrollDirection="both"
              (onLazyLoad)="loadCourtBookingsRevenue($event)" [totalRecords]="totalRecords" [loading]="loading"
              [rowsPerPageOptions]="paginationOption" styleClass="p-datatable-gridlines p-datatable-striped">
              <ng-template pTemplate="header" let-columns>
                <tr>
                  <th pfrozencolumn="" class="mobileNumberTD p-element text-nowrap" style="left: 0px"
                      pSortableColumn="mobileNumber">
                    <div class="p-d-flex p-jc-between p-ai-center"> Mobile Number <p-sortIcon
                        field="mobileNumber"></p-sortIcon>
                    </div>
                  </th>

                  <th pSortableColumn="username" class="userNameTD">
                    <div class="p-d-flex p-jc-between p-ai-center"> Username <p-sortIcon field="username"></p-sortIcon>
                    </div>
                  </th>
                  <th class="userNameTD" pSortableColumn="bookingId">
                    <div class="p-d-flex p-jc-between p-ai-center"> Booking ID <p-sortIcon
                        field="bookingId"></p-sortIcon>
                    </div>
                  </th>
                  <th class="transferCreditTD" pSortableColumn="bookingDate">
                    <div class="p-d-flex p-jc-between p-ai-center"> Booking Date <p-sortIcon
                        field="bookingDate"></p-sortIcon>
                    </div>
                  </th>
                  <th class="propertyNameTd" pSortableColumn="propertyName"
                      [ngClass]="hide ? 'hide-bank-small  ' : 'show-bank-small '">
                    <div class="p-d-flex p-jc-between p-ai-center"> Property Name <p-sortIcon field="propertyName"></p-sortIcon>
                    </div>
                  </th>
                  <th class="BankDteailsTD" pSortableColumn="venueId">
                    <div class="p-d-flex p-jc-between p-ai-center"> Venue ID <p-sortIcon
                        field="venueId"></p-sortIcon>
                    </div>
                  </th>
                  <th class="BankDteailsTD" pSortableColumn="venueName" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <div class="p-d-flex p-jc-between p-ai-center"> Venue Name <p-sortIcon
                        field="venueName"></p-sortIcon>
                    </div>
                  </th>
                  <th class="BankDteailsTD" pSortableColumn="venueCity" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <div class="p-d-flex p-jc-between p-ai-center"> Venue City <p-sortIcon
                        field="venueCity"></p-sortIcon>
                    </div>
                  </th>
                  <th class="BankDteailsTD" pSortableColumn="venueState" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <div class="p-d-flex p-jc-between p-ai-center"> Venue State <p-sortIcon
                        field="venueState"></p-sortIcon>
                    </div>
                  </th>
                  <th class="BankDteailsTD" pSortableColumn="venueCountry" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <div class="p-d-flex p-jc-between p-ai-center"> Venue Country <p-sortIcon
                        field="venueCountry"></p-sortIcon>
                    </div>
                  </th>
                  <th class="BankDteailsTD" pSortableColumn="bookingStartTime" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <div class="p-d-flex p-jc-between p-ai-center"> Booking Start Time <p-sortIcon
                        field="bookingStartTime"></p-sortIcon>
                    </div>
                  </th>
                  <th class="BankDteailsTD" pSortableColumn="bookingEndTime" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <div class="p-d-flex p-jc-between p-ai-center"> Booking End Time <p-sortIcon
                        field="bookingEndTime"></p-sortIcon>
                    </div>
                  </th>
                  <th class="BankDteailsTD" pSortableColumn="bookingHours" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <div class="p-d-flex p-jc-between p-ai-center"> Booking Hours <p-sortIcon
                        field="bookingHours"></p-sortIcon>
                    </div>
                  </th>
                  <th class="BankDteailsTD" pSortableColumn="bookingAmount" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <div class="p-d-flex p-jc-between p-ai-center"> Booking Amout <p-sortIcon
                        field="bookingAmount"></p-sortIcon>
                    </div>
                  </th>
                  <th class="BankDteailsTD" pSortableColumn="couponApplied" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <div class="p-d-flex p-jc-between p-ai-center"> Coupon Applied <p-sortIcon
                        field="couponApplied"></p-sortIcon>
                    </div>
                  </th>
                  <th class="BankDteailsTD" pSortableColumn="couponDiscountAmountVenue" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <div class="p-d-flex p-jc-between p-ai-center"> Coupon Discount Amount (Venue) <p-sortIcon
                        field="couponDiscountAmountVenue"></p-sortIcon>
                    </div>
                  </th>
                  <th class="BankDteailsTD" pSortableColumn="couponDiscountAmountTPL" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <div class="p-d-flex p-jc-between p-ai-center"> Coupon Discount Amount (TPL) <p-sortIcon
                        field="couponDiscountAmountTPL"></p-sortIcon>
                    </div>
                  </th>
                  <th class="BankDteailsTD" pSortableColumn="rescheduleBookingId" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <div class="p-d-flex p-jc-between p-ai-center"> Reschedule Booking ID <p-sortIcon
                        field="rescheduleBookingId"></p-sortIcon>
                    </div>
                  </th>
                  <th class="BankDteailsTD" pSortableColumn="onlineAddOnProducts" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <div class="p-d-flex p-jc-between p-ai-center"> Online Add on Products <p-sortIcon
                        field="onlineAddOnProducts"></p-sortIcon>
                    </div>
                  </th>
                  <th class="BankDteailsTD" pSortableColumn="onlineAddOnAmount" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <div class="p-d-flex p-jc-between p-ai-center"> Online Add on Amount <p-sortIcon
                        field="onlineAddOnAmount"></p-sortIcon>
                    </div>
                  </th>
                  <th class="BankDteailsTD" pSortableColumn="tplCommissionPercent" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <div class="p-d-flex p-jc-between p-ai-center"> TPL Commission % <p-sortIcon
                        field="tplCommissionPercent"></p-sortIcon>
                    </div>
                  </th>
                  <th class="BankDteailsTD" pSortableColumn="tplCommission" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <div class="p-d-flex p-jc-between p-ai-center"> TPL Commission <p-sortIcon
                        field="tplCommission"></p-sortIcon>
                    </div>
                  </th>
                  <th class="BankDteailsTD" pSortableColumn="onlineAddOnTPLCommissionPercent" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <div class="p-d-flex p-jc-between p-ai-center"> Online Add On TPL Commission % <p-sortIcon
                        field="onlineAddOnTPLCommissionPercent"></p-sortIcon>
                    </div>
                  </th>
                  <th class="BankDteailsTD" pSortableColumn="onlineAddOnTPLCommission" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <div class="p-d-flex p-jc-between p-ai-center"> Online Add On TPL Commission <p-sortIcon
                        field="onlineAddOnTPLCommission"></p-sortIcon>
                    </div>
                  </th>
                  <th class="BankDteailsTD" pSortableColumn="tplRevenue" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <div class="p-d-flex p-jc-between p-ai-center"> TPL Revenue <p-sortIcon
                        field="tplRevenue"></p-sortIcon>
                    </div>
                  </th>
                  <th class="BankDteailsTD" pSortableColumn="gstAmount" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <div class="p-d-flex p-jc-between p-ai-center"> GST Amount <p-sortIcon
                        field="gstAmount"></p-sortIcon>
                    </div>
                  </th>
                  <th class="BankDteailsTD" pSortableColumn="venuePayout" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <div class="p-d-flex p-jc-between p-ai-center"> Venue Payout <p-sortIcon
                        field="venuePayout"></p-sortIcon>
                    </div>
                  </th>
                  <th class="BankDteailsTD" pSortableColumn="tplShare" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <div class="p-d-flex p-jc-between p-ai-center"> TPL Share <p-sortIcon
                        field="tplShare"></p-sortIcon>
                    </div>
                  </th>
                  <th class="sorting_disabled text-nowrap p-element p-frozen-column action-button-td"   style="justify-content: center;">
                    <div>Action</div>
                  </th>
                </tr>

                <tr>
                  <th pfrozencolumn="" class="mobileNumberTD p-element text-nowrap">
                    <input pInputText type="text"
                      (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'mobileNumber', 'contains')"
                      [value]="dt.filters['mobileNumber'] ? dt.filters['mobileNumber'].value : ''" />
                  </th>

                  <th class="userNameTD p-element text-nowrap">
                    <input pInputText type="text"
                      (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'username', 'contains')"
                      [value]="dt.filters['username'] ? dt.filters['username'].value : ''" />
                  </th>
                  <th class="userNameTD p-element text-nowrap">
                    <input pInputText type="text"
                      (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'bookingId', 'contains')"
                      [value]="dt.filters['bookingId'] ? dt.filters['bookingId'].value : ''" />
                  </th>
                  <th class="transferCreditTD p-element text-nowrap">
                    <input pInputText type="date"
                      (change)="setDownloadFlag(); dt.filter($event.target.value, 'bookingDate', 'equals')"
                      [value]="dt.filters['bookingDate'] ? dt.filters['bookingDate'].value : ''" />
                  </th>
                  <th class="propertyNameTd show-col">
                    <input pInputText type="text"
                      (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'propertyName', 'contains')"
                      [value]="dt.filters['propertyName'] ? dt.filters['propertyName'].value : ''" />
                  </th>
                  <th class="BankDteailsTD show-col">
                    <input pInputText type="text"
                      (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'venueId', 'contains')"
                      [value]="dt.filters['venueId'] ? dt.filters['venueId'].value : ''" />
                  </th>
                  <th class="BankDteailsTD show-col" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <input pInputText type="text"
                      (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'venueName', 'contains')"
                      [value]="dt.filters['venueName'] ? dt.filters['venueName'].value : ''" />
                  </th>
                  <th class="BankDteailsTD show-col" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <input pInputText type="text"
                      (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'venueCity', 'contains')"
                      [value]="dt.filters['venueCity'] ? dt.filters['venueCity'].value : ''" />
                  </th>
                  <th class="BankDteailsTD show-col" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <input pInputText type="text"
                      (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'venueState', 'contains')"
                      [value]="dt.filters['venueState'] ? dt.filters['venueState'].value : ''" />
                  </th>
                  <th class="BankDteailsTD show-col" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <input pInputText type="text"
                      (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'venueCountry', 'contains')"
                      [value]="dt.filters['venueCountry'] ? dt.filters['venueCountry'].value : ''" />
                  </th>
                  <th class="BankDteailsTD show-col" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <input pInputText type="text"
                      (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'bookingStartTime', 'contains')"
                      [value]="dt.filters['bookingStartTime'] ? dt.filters['bookingStartTime'].value : ''" />
                  </th>
                  <th class="BankDteailsTD show-col" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <input pInputText type="text"
                      (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'bookingEndTime', 'contains')"
                      [value]="dt.filters['bookingEndTime'] ? dt.filters['bookingEndTime'].value : ''" />
                  </th>
                  <th class="BankDteailsTD show-col" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <input pInputText type="number"
                      (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'bookingHours', 'equals')"
                      [value]="dt.filters['bookingHours'] ? dt.filters['bookingHours'].value : ''" />
                  </th>
                  <th class="BankDteailsTD show-col" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <input pInputText type="number"
                      (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'bookingAmount', 'equals')"
                      [value]="dt.filters['bookingAmount'] ? dt.filters['bookingAmount'].value : ''" />
                  </th>
                  <th class="BankDteailsTD show-col" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <input pInputText type="text"
                      (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'couponApplied', 'contains')"
                      [value]="dt.filters['couponApplied'] ? dt.filters['couponApplied'].value : ''" />
                  </th>
                  <th class="BankDteailsTD show-col" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <input pInputText type="number"
                      (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'couponDiscountAmountVenue', 'equals')"
                      [value]="dt.filters['couponDiscountAmountVenue'] ? dt.filters['couponDiscountAmountVenue'].value : ''" />
                  </th>
                  <th class="BankDteailsTD show-col" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <input pInputText type="number"
                      (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'couponDiscountAmountTPL', 'equals')"
                      [value]="dt.filters['couponDiscountAmountTPL'] ? dt.filters['couponDiscountAmountTPL'].value : ''" />
                  </th>
                  <th class="BankDteailsTD show-col" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <input pInputText type="text"
                      (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'rescheduleBookingId', 'contains')"
                      [value]="dt.filters['rescheduleBookingId'] ? dt.filters['rescheduleBookingId'].value : ''" />
                  </th>
                  <th class="BankDteailsTD show-col" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <input pInputText type="text"
                      (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'onlineAddOnProducts', 'contains')"
                      [value]="dt.filters['onlineAddOnProducts'] ? dt.filters['onlineAddOnProducts'].value : ''" />
                  </th>
                  <th class="BankDteailsTD show-col" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <input pInputText type="number"
                      (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'onlineAddOnAmount', 'equals')"
                      [value]="dt.filters['onlineAddOnAmount'] ? dt.filters['onlineAddOnAmount'].value : ''" />
                  </th>
                  <th class="BankDteailsTD show-col" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <input pInputText type="number"
                      (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'tplCommissionPercent', 'equals')"
                      [value]="dt.filters['tplCommissionPercent'] ? dt.filters['tplCommissionPercent'].value : ''" />
                  </th>
                  <th class="BankDteailsTD show-col" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <input pInputText type="number"
                      (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'tplCommission', 'equals')"
                      [value]="dt.filters['tplCommission'] ? dt.filters['tplCommission'].value : ''" />
                  </th>
                  <th class="BankDteailsTD show-col" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <input pInputText type="number"
                      (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'onlineAddOnTPLCommissionPercent', 'equals')"
                      [value]="dt.filters['onlineAddOnTPLCommissionPercent'] ? dt.filters['onlineAddOnTPLCommissionPercent'].value : ''" />
                  </th>
                  <th class="BankDteailsTD show-col" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <input pInputText type="number"
                      (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'onlineAddOnTPLCommission', 'equals')"
                      [value]="dt.filters['onlineAddOnTPLCommission'] ? dt.filters['onlineAddOnTPLCommission'].value : ''" />
                  </th>
                  <th class="BankDteailsTD show-col" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <input pInputText type="number"
                      (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'tplRevenue', 'equals')"
                      [value]="dt.filters['tplRevenue'] ? dt.filters['tplRevenue'].value : ''" />
                  </th>
                  <th class="BankDteailsTD show-col" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <input pInputText type="number"
                      (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'gstAmount', 'equals')"
                      [value]="dt.filters['gstAmount'] ? dt.filters['gstAmount'].value : ''" />
                  </th>
                  <th class="BankDteailsTD show-col" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <input pInputText type="number"
                      (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'venuePayout', 'equals')"
                      [value]="dt.filters['venuePayout'] ? dt.filters['venuePayout'].value : ''" />
                  </th>
                  <th class="BankDteailsTD show-col" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <input pInputText type="number"
                      (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'tplShare', 'equals')"
                      [value]="dt.filters['tplShare'] ? dt.filters['tplShare'].value : ''" />
                  </th>
                  <th class="text-nowrap p-element p-frozen-column action-button-td"  style="justify-content: center;">
                    <div class="buttonColumn">
                      <button class="addBTn" (click)="addColumns()" [ngClass]="hide ? 'show-column ' : 'hide-column'">
                        + Show Column
                      </button>
                      <button class="removeBTn" (click)="removeColumns()"
                        [ngClass]="hide ? 'hide-column' : 'show-column '">
                        - Hide Column
                      </button>

                    </div>
                  </th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-courtBookingsRevenueList>
                <tr class="p-selectable-row">
                  <td pfrozencolumn="" class="mobileNumberTD p-element text-nowrap">
                    <div class="textOverFlow1" pTooltip="	{{courtBookingsRevenueList.mobileNumber}}" tooltipPosition="bottom">
                      {{courtBookingsRevenueList.mobileNumber}}
                    </div>
                  </td>
                  <td class="userNameTD">
                    {{ courtBookingsRevenueList.username }}
                  </td>
                  <td class="userNameTD">
                    {{ courtBookingsRevenueList.bookingId }}
                  </td>
                  <td class="transferCreditTD">
                    {{ courtBookingsRevenueList.bookingDate | date:'dd/MM/yyyy' }}
                  </td>
                  <td class="propertyNameTd ">
                    {{ courtBookingsRevenueList.propertyName }}
                  </td>
                  <td class="BankDteailsTD ">
                    {{ courtBookingsRevenueList?.venueId }}
                  </td>
                  <td class="BankDteailsTD " [ngClass]="hide ? 'hide-column' : 'show-column'">
                    {{ courtBookingsRevenueList?.venueName }}
                  </td>
                  <td class="BankDteailsTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    {{ courtBookingsRevenueList?.venueCity }}
                  </td>
                  <td class="BankDteailsTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    {{ courtBookingsRevenueList?.venueState }}
                  </td>
                  <td class="BankDteailsTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    {{ courtBookingsRevenueList?.venueCountry }}
                  </td>
                  <td class="BankDteailsTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    {{ courtBookingsRevenueList?.bookingStartTime }}
                  </td>
                  <td class="BankDteailsTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    {{ courtBookingsRevenueList?.bookingEndTime }}
                  </td>
                  <td class="BankDteailsTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    {{ courtBookingsRevenueList?.bookingHours }}
                  </td>
                  <td class="BankDteailsTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    {{ courtBookingsRevenueList?.bookingAmount | number:'0.2-2' }}
                  </td>
                  <td class="BankDteailsTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    {{ courtBookingsRevenueList?.couponApplied || '-' }}
                  </td>
                  <td class="BankDteailsTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    {{ courtBookingsRevenueList?.couponDiscountAmountVenue > 0 ? (courtBookingsRevenueList.couponDiscountAmountVenue | number:'0.2-2') : '-' }}
                  </td>
                  <td class="BankDteailsTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    {{ courtBookingsRevenueList?.couponDiscountAmountTPL > 0 ? (courtBookingsRevenueList.couponDiscountAmountTPL | number:'0.2-2') : '-' }}
                  </td>
                  <td class="BankDteailsTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    {{ courtBookingsRevenueList?.rescheduleBookingId || '-' }}
                  </td>
                  <td class="BankDteailsTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    {{ courtBookingsRevenueList?.onlineAddOnProducts }}
                  </td>
                  <td class="BankDteailsTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    {{ courtBookingsRevenueList?.onlineAddOnAmount | number:'0.2-2' }}
                  </td>
                  <td class="BankDteailsTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    {{ courtBookingsRevenueList?.tplCommissionPercent }}
                  </td>
                  <td class="BankDteailsTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    {{ courtBookingsRevenueList?.tplCommission | number:'0.2-2' }}
                  </td>
                  <td class="BankDteailsTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    {{ courtBookingsRevenueList?.onlineAddOnTPLCommissionPercent }}
                  </td>
                  <td class="BankDteailsTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    {{ courtBookingsRevenueList?.onlineAddOnTPLCommission | number:'0.2-2' }}
                  </td>
                  <td class="BankDteailsTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    {{ courtBookingsRevenueList?.tplRevenue | number:'0.2-2' }}
                  </td>
                  <td class="BankDteailsTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    {{ courtBookingsRevenueList?.gstAmount | number:'0.2-2' }}
                  </td>
                  <td class="BankDteailsTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    {{ courtBookingsRevenueList?.venuePayout | number:'0.2-2' }}
                  </td>
                  <td class="BankDteailsTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    {{ courtBookingsRevenueList?.tplShare | number:'0.2-2' }}
                  </td>
                  <td class="text-nowrap p-element p-frozen-column action-button-td">
                    
                  </td>
                </tr>
              </ng-template>

              <ng-template pTemplate="emptymessage">
                <tr>
                  <td colspan="7">Court bookings revenue list not found.</td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>
      </div>
    </div>
    <p-confirmDialog [style]="{ width: '400px' }" id="confirmDialog"></p-confirmDialog>
  </div>
</div>
